// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
@layer properties;
.text-display {
  font-size: var(--text-2xl, 1.5rem);
  line-height: var(--tw-leading, var(--text-2xl--line-height, calc(2 / 1.5)));
  --tw-font-weight: var(--font-weight-bold, 700);
  font-weight: var(--font-weight-bold, 700);
  --tw-tracking: var(--tracking-tight, -0.025em);
  letter-spacing: var(--tracking-tight, -0.025em);
  @media (width >= 40rem) {
    font-size: var(--text-3xl, 1.875rem);
    line-height: var(--tw-leading, var(--text-3xl--line-height, calc(2.25 / 1.875)));
  }
  @media (width >= 64rem) {
    font-size: var(--text-4xl, 2.25rem);
    line-height: var(--tw-leading, var(--text-4xl--line-height, calc(2.5 / 2.25)));
  }
}
.text-heading-1 {
  font-size: var(--text-xl, 1.25rem);
  line-height: var(--tw-leading, var(--text-xl--line-height, calc(1.75 / 1.25)));
  --tw-font-weight: var(--font-weight-semibold, 600);
  font-weight: var(--font-weight-semibold, 600);
  @media (width >= 40rem) {
    font-size: var(--text-2xl, 1.5rem);
    line-height: var(--tw-leading, var(--text-2xl--line-height, calc(2 / 1.5)));
  }
  @media (width >= 64rem) {
    font-size: var(--text-3xl, 1.875rem);
    line-height: var(--tw-leading, var(--text-3xl--line-height, calc(2.25 / 1.875)));
  }
}
.text-heading-2 {
  font-size: var(--text-lg, 1.125rem);
  line-height: var(--tw-leading, var(--text-lg--line-height, calc(1.75 / 1.125)));
  --tw-font-weight: var(--font-weight-semibold, 600);
  font-weight: var(--font-weight-semibold, 600);
  @media (width >= 40rem) {
    font-size: var(--text-xl, 1.25rem);
    line-height: var(--tw-leading, var(--text-xl--line-height, calc(1.75 / 1.25)));
  }
  @media (width >= 64rem) {
    font-size: var(--text-2xl, 1.5rem);
    line-height: var(--tw-leading, var(--text-2xl--line-height, calc(2 / 1.5)));
  }
}
.text-heading-3 {
  font-size: var(--text-base, 1rem);
  line-height: var(--tw-leading, var(--text-base--line-height, calc(1.5 / 1)));
  --tw-font-weight: var(--font-weight-semibold, 600);
  font-weight: var(--font-weight-semibold, 600);
  @media (width >= 40rem) {
    font-size: var(--text-lg, 1.125rem);
    line-height: var(--tw-leading, var(--text-lg--line-height, calc(1.75 / 1.125)));
  }
}
.text-body {
  font-size: var(--text-sm, 0.875rem);
  line-height: var(--tw-leading, var(--text-sm--line-height, calc(1.25 / 0.875)));
  --tw-leading: var(--leading-relaxed, 1.625);
  line-height: var(--leading-relaxed, 1.625);
  @media (width >= 40rem) {
    font-size: var(--text-base, 1rem);
    line-height: var(--tw-leading, var(--text-base--line-height, calc(1.5 / 1)));
  }
}
.text-caption {
  font-size: var(--text-xs, 0.75rem);
  line-height: var(--tw-leading, var(--text-xs--line-height, calc(1 / 0.75)));
  color: var(--color-gray-500, oklch(55.1% 0.027 264.364));
  @media (width >= 40rem) {
    font-size: var(--text-sm, 0.875rem);
    line-height: var(--tw-leading, var(--text-sm--line-height, calc(1.25 / 0.875)));
  }
  @media (prefers-color-scheme: dark) {
    color: var(--color-gray-400, oklch(70.7% 0.022 261.325));
  }
}
.text-label {
  font-size: var(--text-sm, 0.875rem);
  line-height: var(--tw-leading, var(--text-sm--line-height, calc(1.25 / 0.875)));
  --tw-font-weight: var(--font-weight-medium, 500);
  font-weight: var(--font-weight-medium, 500);
  color: var(--color-gray-700, oklch(37.3% 0.034 259.733));
  @media (prefers-color-scheme: dark) {
    color: var(--color-gray-300, oklch(87.2% 0.01 258.338));
  }
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@property --tw-tracking {
  syntax: "*";
  inherits: false;
}
@property --tw-leading {
  syntax: "*";
  inherits: false;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-font-weight: initial;
      --tw-tracking: initial;
      --tw-leading: initial;
    }
  }
}
`, "",{"version":3,"sources":["<no source>","webpack://./src/styles/typography.css"],"names":[],"mappings":"AAAA,iEAAA;ACGkB,iBAAS;AAD3B;EACS,kCAAQ;EAAR,2EAAQ;EAAC,8CAAS;EAAT,yCAAS;EAAC,8CAAc;EAAd,+CAAc;EAAC;IAAA,oCAAW;IAAX,gFAAW;EAAA;EAAC;IAAA,mCAAW;IAAX,8EAAW;EAAA;AACjE;AAED;EACS,kCAAO;EAAP,8EAAO;EAAC,kDAAa;EAAb,6CAAa;EAAC;IAAA,kCAAW;IAAX,2EAAW;EAAA;EAAC;IAAA,oCAAW;IAAX,gFAAW;EAAA;AACrD;AAED;EACS,mCAAO;EAAP,+EAAO;EAAC,kDAAa;EAAb,6CAAa;EAAC;IAAA,kCAAU;IAAV,8EAAU;EAAA;EAAC;IAAA,kCAAW;IAAX,2EAAW;EAAA;AACpD;AAED;EACS,iCAAS;EAAT,4EAAS;EAAC,kDAAa;EAAb,6CAAa;EAAC;IAAA,mCAAU;IAAV,+EAAU;EAAA;AAC1C;AAED;EACS,mCAAO;EAAP,+EAAO;EAAc,2CAAe;EAAf,0CAAe;EAA5B;IAAA,iCAAY;IAAZ,4EAAY;EAAA;AAC5B;AAED;EACS,kCAAO;EAAP,2EAAO;EAAY,wDAAa;EAAxB;IAAA,mCAAU;IAAV,+EAAU;EAAA;EAAe;IAAA,wDAAkB;EAAA;AAC3D;AAED;EACS,mCAAO;EAAP,+EAAO;EAAC,gDAAW;EAAX,2CAAW;EAAC,wDAAa;EAAC;IAAA,uDAAkB;EAAA;AAC5D;AAzBiB;EAAA,WAAS;EAAT,eAAS;AAAA;AAAC;EAAA,WAAc;EAAd,eAAc;AAAA;AAgBZ;EAAA,WAAe;EAAf,eAAe;AAAA;AAhB3B;EAAA;IAAA;MAAA,yBAAS;MAAC,sBAAc;MAgBZ,qBAAe;IAhBlB;EAAA;AAAA","sourcesContent":[null,"@import 'tailwindcss' reference;\n\n.text-display {\n  @apply text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl;\n}\n\n.text-heading-1 {\n  @apply text-xl font-semibold sm:text-2xl lg:text-3xl;\n}\n\n.text-heading-2 {\n  @apply text-lg font-semibold sm:text-xl lg:text-2xl;\n}\n\n.text-heading-3 {\n  @apply text-base font-semibold sm:text-lg;\n}\n\n.text-body {\n  @apply text-sm sm:text-base leading-relaxed;\n}\n\n.text-caption {\n  @apply text-xs sm:text-sm text-gray-500 dark:text-gray-400;\n}\n\n.text-label {\n  @apply text-sm font-medium text-gray-700 dark:text-gray-300;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
